<template>
  <div style=" 
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index:3"
    :style="{ backgroundColor: bg }">

    <v-container grid-list-xl>

     

		  <v-layout
		      flex-child
		      wrap
		      class="justify-center"
		      style="margin-bottom:-8vh"
		    >	

		    <v-flex
	        xs12
	        md4
	        d-flex
          style="margin-top:60px"
	      >

			    <v-form
				    ref="form"
				    v-model="valid"
				    lazy-validation
				    style="margin:30px 0 0 0"
            v-if="!finish && !pendingFinish"
				  >
    				  <h4 style="display:block"> Add project details</h4>
    	    		<label style="font-size:12px; font-weight:600;color:silver;margin:30px 0 10px 0">Template</label>
    	     		<br/>
    	     		<div style="float:left;width:8px;height:8px;border-radius:10px;background-color:rgb(120, 50, 250);margin:6px;margin-right:16px;"></div>
    	    	 		<span style="">{{contractType()}}</span>

                <v-flex d-flex>
    				      <v-text-field
    				      v-model="name"
      				      :counter="30"
      				      :rules="nameRules"
      				      label="Name"
      				      required
      				      outline
      				      style="margin:30px 0"
      				    ></v-text-field>
                </v-flex>
                <v-flex style="margin:-50px;" d-flex>  
                  <span style="font-size:12px; font-weight:600;color:silver;margin:30px 0 20px 40px">Network</span>
                </v-flex>

                
                <v-flex d-flex>  
                  <v-radio-group  v-model="network">
<!--                     <v-radio
                      value="telosTestnet"
                      key="1"
                      label="Testnet"
                      disabled
                    ></v-radio> -->
                    <v-radio
                      value="eosMainnet"
                      key="2"
                      label="EOS"
                      disabled
                    ></v-radio>
                    <v-radio
                      value="telosMainnet"
                      key="3"
                      label="TELOS"
                      
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <span class="caption" style="color:silver">To discuss using the EOS main network for your application, please make a booking <a href="https://calendly.com/smartpress/integration-session" target="_blank">here</a></span><br/><br/>
    				    

				    <!-- <v-btn
				      :disabled="!valid"
				      color="success"
				      @click="pushNewContract"
				    >Review and deploy</v-btn> -->

				 		<v-btn
				      v-if="clearToFinish"
				      color="success"
				      @click="pushNewContract();"
				    >Submit</v-btn>
 
				  </v-form>

          

          <v-flex d-flex>
            <h4 v-if="finish" style="display:block">You're done! Take me to my dashboard</h4><br/><br/>
          </v-flex>
          <v-flex d-flex>
            <v-btn
              v-if="finish"
              color="success"
              @click="goToHomePage"
            >Let's go</v-btn>
          </v-flex>

				</v-flex>
			</v-layout>
	  </v-container>
	  <div style="position:fixed; top:40px; right:100px; width:40px; height:40px">
	  	<v-btn to="/myContracts" round flat style="font-weight:600; color:gray">x</v-btn>
	  </div>
	  <div style="position:fixed; top:40px; left:40px; width:40px; height:40px">
	  	<v-btn @click="$router.go(-1)" round flat style="font-weight:600; color:gray"><</v-btn>
	  </div>

    <DialogLoader v-if="pendingFinish" :message="'Deploying contract'"  :dialog="true"></DialogLoader>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DialogLoader from "@/components/loading/dialogLoader.vue"

export default {
  components: {
    DialogLoader
  },
    data () {
      return {
      	network: 'telosMainnet',
        bg: 'black',
        template: 
          { icon: '', iconClass: 'grey lighten-1 white--text', title: 'Basic database', subtitle: 'Create your censorship resistant endpoint', route: "myContracts" },
         
        valid: true,
	      name: '',
	      nameRules: [
	        v => !!v || 'Name is required',
	        v => (v && v.length <= 30) || 'Name must be less than 30 characters'
	      ],
	      email: '',
	      emailRules: [
	        v => !!v || 'E-mail is required',
	        v => /.+@.+/.test(v) || 'E-mail must be valid'
	      ],
	      select: null,
	      items: [
	        'Item 1',
	        'Item 2',
	        'Item 3',
	        'Item 4'
	      ],
	      checkbox: false,
        finish: false,
        pendingFinish: false
      }
    },
    created: function () {
    	this.$store.dispatch('contractsDb/getMyContracts')
      .then(() => {
        if(this.myContracts.Count){

          if (this.myContracts.Count == 0) {

          } else {
            this.$router.push('../../../myContracts')
          }
        }
        
      })


      

    	if (this.isDark) {
    		this.bg = 'black'
    	} else {
    		this.bg = 'white'
    	}
    },
    watch: {
      pendingFinish: function () {
        let self = this
        setTimeout(function  () {
          self.finish = true
          self.pendingFinish = false;
        }, 8000)
      },
      myContracts:() => {

        console.log(this.myContracts)
        if (this.myContracts.Count == 0) {

        } else {
          this.$router.push('../../../myContracts')
        }
      }
    },
    computed: {
      clearToFinish: function () {
        if (this.name.length > 2) {
          return true
        } else {
          return false
        }
      },
      ...mapState({
        myContracts: state => state.contractsDb.myContracts
      }),
    },
    methods: {
      contractType: function () {
        if (this.$route.params.contractType == 'nft') {
          return 'Digital asset'
        } else if (this.$route.params.contractType == 'token') {
          return 'Token'
        } else if (this.$route.params.contractType == 'database') {
          return 'Database'
        } else if (this.$route.params.contractType == 'blank') {
          return 'Blank slate'
        }
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      pushNewContract() {
        console.log('pushing contract')

        this.$cookies.set("newContractShouldTour", 'true')
        this.$cookies.remove('afterLoginGoToTokenDetail')

        // Create a user account and the selected contract and api key
        this.$store.dispatch('contractsDb/pushNewContract', {
          type: this.$route.params.contractType,
          name: this.name,
          contract_status: 'pending'
        })
        this.$store.dispatch('contractsDb/pushNewContract', {
          type: 'user',
          name: this.name,
          contract_status: 'pending'
        })
        this.$store.dispatch('contractsDb/createApiKey', {
          project_id: this.name,
          status: 'pending'
        })

        this.$cookies.remove('newSignup')
        this.pendingFinish = true
      },
      goToHomePage: function  () {
        // this.$router.push({name: 'myContracts'})
        window.location.pathname = '/myContracts'
      }
    }
}
</script>


<style>

 

<style>